<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li><a href="/#/products" v-on:click="sendMsg">产品中心</a></li>
            <li class="active">数据分析软件</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
            <h1 style="text-align:center;font-size: 20px">数据分析软件</h1>
            <hr>
            <p class="titleP">系统简介</p>
            <p>数据分析软件可进行本地的数据采集以及数据分析。</p>
            <p class="titleP">主要功能</p>
            <div class="content-box">
              <div class="left-box">
                <p>1.定时数据采集</p>
                <p>2.时域加频谱双显</p>
                <p>3.多通道同时显示</p>
                <p>4.多板卡同时采集</p>
                <p>5.多格式数据转存</p>
                <p>6.时域分析</p>
                <p>7.自谱FFT分析</p>
                <p>8.倍频程谱分析</p>
              </div>
              <div class="right-box">
                <img src="../../../assets/product/wave/c1.png" alt="">
                <img src="../../../assets/product/wave/c2.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .content-box{
    display: flex;
    flex-wrap: wrap;
  }

  .left-box{
    width: 30%;
  }

  .right-box{
    width: 70%;
    text-indent: 0px;
    padding-top: 20px;
  }

  .right-box img{
    width: 49%;
    height: 200px;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/wave/wave.vue